/**
 * Cloud trigger: clicks #gowishBlueButton inside the same .product-details as this control.
 */
(function () {
  function onDocumentClick(event) {
    const trigger = event.target.closest('.gowish-wishlist-cloud');
    if (!trigger) return;

    const details = trigger.closest('.product-details');
    if (!details) return;

    const gowish = details.querySelector('#gowishBlueButton');
    if (!gowish) return;

    if (typeof gowish.click === 'function') {
      gowish.click();
    }
  }

  document.addEventListener('click', onDocumentClick);
})();
